export default "__VITE_PUBLIC_ASSET__ad6ea791__"